import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

interface PrivateRouteProps {
  isAuthenticated: boolean;
  redirectPath?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  isAuthenticated
}) => {
  // Show loading state while App.tsx handles SSO redirect
  // App.tsx will redirect to SSO if not authenticated, so we just show loading here
  if (!isAuthenticated) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          Connecting to CYNAYD One…
        </Typography>
      </Box>
    );
  }

  return <Outlet />;
};

export default PrivateRoute; 